<template lang="pug">
  v-card.mx-auto(max-width='100%')
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-dialog(v-model='dialogAddLocation' :fullscreen="isMobile" :max-width='!isMobile ? "600px" : ""' v-if="dialogAddLocation")
      add-user-location(:currentPosition="currentPosition" @closeModalUserLocation="dialogAddLocation=false")
    v-btn(fab small color="primary" @click="$emit('closeModalUserLocation')" style="position: absolute; z-index: 999; top: 10px; right: 0px;")
      v-icon.primary.rounded mdi-close
    v-card-text.text--primary(style="padding: 0px; padding: 0px; overflow-y: scroll;")
      v-card-title
        .text-center DIRECCIÓN DE ENTREGA
    v-card.mx-auto(max-width='344' outlined='')
      v-list-item(three-line='')
        v-list-item-content
          .overline.mb-4 UBICACIÓN PREDETERMINADA
          label.headline.mb-1 {{defaultLocationVar.direction}}
        v-icon mdi-map-marker
    br
    br
    v-card.mx-auto(max-width='344' outlined='' v-for='(location, i) in locationsLst' :key='i' style="margin-top: 10px; margin-bottom: 10px;")
      v-list-item(three-line='')
        v-list-item-content
          .overline.mb-4 {{location.data.direction}}
          label.headline.mb-1 {{location.data.title}}
        v-icon mdi-map-marker
        v-btn(text small color="primary" @click="setDefaultLocation(location.data)") Dirección principal
    br
    br
    v-card-actions
      v-btn(color='#009da5'   style="width: 100%; position: absolute; bottom: 0px;" @click="dialogAddLocation = true")
        | AGREGAR DIRECCIÓN
</template>

<script>
  export default {
    components: {
      AddUserLocation: () => import('@/views/marketplace/components/AddUserLocation'),
    },
    props: {
      currentPosition: null,
    },
    data () {
      return {
        dialogAddLocation: false,
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      defaultLocationVar () {
        if (this.$store.state.users.profile.defaultlocation) {
          return this.$store.state.users.profile.defaultlocation
        } else {
          return {
            direction: this.currentPosition,
          }
        }
      },
      locationsLst () {
        const profile = this.$store.state.users.profile
        const arrLocations = profile.locations
        let arr = []
        if (arrLocations) {
          arr = Object.keys(arrLocations).map(location => {
            return { id: location, data: arrLocations[location] }
          })
        }
        return arr
      },
    },
    created () {

    },
    methods: {
      setDefaultLocation (data) {
        this.$store.dispatch('users/addDefaultUserLocation', data).then((res) => {
          if (res) {
            this.setDataNotification(true, 'success', 'Dirección principal actualizada correctamente.')
          } else {
            this.setDataNotification(true, 'error', 'Error al momento de guardar la dirección.')
          }
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
    },
  }
</script>
